package ai.jessie.web.pages

import ai.jessie.web.authentication.AuthenticationSessionState
import ai.jessie.web.authentication.LocalAuthenticationSessionPort
import ai.jessie.web.authentication.SessionStatus
import ai.jessie.web.authentication.authenticationSection
import ai.jessie.web.onboarding.authenticatedEntry
import ai.jessie.web.theme.entryFrame
import ai.jessie.web.theme.linkButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun homePage() {
    val port = LocalAuthenticationSessionPort.current
    val scope = rememberCoroutineScope()
    val session = remember(port, scope) { AuthenticationSessionState(port, scope) }
    val outcomes =
        window.location.search.removePrefix("?").split("&").filter {
            it.startsWith("authentication_outcome=")
        }
    val outcome = outcomes.singleOrNull()?.substringAfter("=")
    LaunchedEffect(session) { if (!AppGlobals.isExporting) session.refresh() }
    // The authentication section renders its own logout forms, so the frame offers none.
    entryFrame("Jessie", authenticationRequired = true) {
        authenticationSection(outcome, session.state, session.actions)
        if (session.state.status == SessionStatus.AUTHENTICATED) authenticatedEntry()
        P { Text("Erstelle dein Konto mit deiner E-Mail-Adresse und bestätige sie anschliessend.") }
        P { linkButton("Konto erstellen", "/api/v1/registration/start") }
    }
}
